import { useEffect, createContext, useContext } from 'react'
import { io } from 'socket.io-client'
import { useQueryClient } from '@tanstack/react-query'
import { useAuthStore } from '../store/authStore'

const SocketContext = createContext(null)

export const useSocket = () => useContext(SocketContext)

export default function SocketProvider({ children }) {
  const queryClient = useQueryClient()
  const { user } = useAuthStore()

  useEffect(() => {
    // Determine socket URL from API base
    const socketUrl = process.env.REACT_APP_API_URL?.replace('/api', '') || 'https://jaritex-api.thetasol.com'

    const socket = io(socketUrl, {
      transports: ['websocket'],
      autoConnect: true,
    })

    socket.on('connect', () => {
      console.log('Admin Socket Connected')
      if (user?.unit_id) {
        socket.emit('join_unit', user.unit_id)
      }
    })

    socket.on('GLOBAL_REFRESH', (data) => {
      console.log('🔄 Global Refresh Signal Received:', data)
      // Invalidate all queries to trigger a fresh background fetch
      queryClient.invalidateQueries()
    })

    return () => {
      socket.disconnect()
    }
  }, [queryClient, user?.unit_id])

  return (
    <SocketContext.Provider value={null}>
      {children}
    </SocketContext.Provider>
  )
}
